import { Liquid } from 'liquidjs';
import constants from 'Constants';
import * as comUtils from "common/utils";
import * as cookieUtils from "common/cookie-utils";
export * from "common/utils";
export * from "common/cookie-utils";


export function liquidRender(template, params) {
  const engine = new Liquid();
  return engine.parseAndRenderSync(template, params);
}

export function tryLiquidRender(value, params, defaultValue='') {
  try {
    value = liquidRender(value, params);
  } catch(error) {
    if (comUtils.isClientProduction()) console.error(error);
    return defaultValue || value;
  }
  return value;
}

export async function evaluateUrlRule(url, predicate, values) {
  if (predicate === constants.REPERKS_WIDGET_URL_PREDICATE_CONTAINS) {
    let contains = false;
    values.forEach((value) => {
      if (url.includes(value)) contains = true
    })

    if (contains) return true;
    return false;
  }

  if (predicate === constants.REPERKS_WIDGET_URL_PREDICATE_DOES_NOT_CONTAIN) {
    let contains = false;
    values.forEach((value) => {
      if (url.includes(value)) contains = true
    })

    if (!contains) return true;
    return false;
  }

  if (predicate === constants.REPERKS_WIDGET_URL_PREDICATE_MATCH_REGEX) {
    let match = false;

    try {
      values.forEach((value) => {
        let regex = new RegExp(value);
        if (regex.test(url)) match = true
      })

    } catch(e) {
      console.error(e);
    }

    if (match) return true;
    return false;
  }

  if (predicate === constants.REPERKS_WIDGET_URL_PREDICATE_DOES_NOT_MATCH_REGEX) {
    let match = false;

    try {
      values.forEach((value) => {
        let regex = new RegExp(value);
        if (regex.test(url)) match = true
      })

    } catch(e) {
      console.error(e);
    }

    if (!match) return true;
    return false;
  }

  return false;
}

export function extractMemberExternalId() {
  let ovData = window.OnVoardData;
  let platform = comUtils.getEcommercePlatform();

  if (platform === 'shopify') {
    if (ovData.customer) return ovData.customer.id;
  }

  if (platform === 'easystore') {
    if (ovData.customer) return ovData.customer.id;
  }

  if (platform === 'bigcommerce') {
    if (ovData.customer) return ovData.customer.id;
  }

  if (platform === 'shopline') {
    if (ovData.customer) return ovData.customer.id;
  }

  if (platform === 'wix') {
    if (ovData.member) return ovData.member.contactId;
  }

  return;
}


export function copyToClipboard(value) {
  // See https://stackoverflow.com/a/38672314/1446284
  var textarea = document.createElement('textarea')
  textarea.id = 'clipboard_element'
  textarea.style.height = 0
  document.body.appendChild(textarea)

  textarea.value = value;
  var selector = document.querySelector('#clipboard_element')

  selector.select()
  document.execCommand('copy')
  document.body.removeChild(textarea);
}

export function isEligiblePage() {
  // won't display in checkout page
  let ovData = window.OnVoardData;
  let platform = comUtils.getEcommercePlatform();

  if (platform === 'shopify') {
    if (window.Shopify && window.Shopify.checkout) return false;
  }

  if (platform === 'easystore') {
    let ineligibleTemplates = [
      "customer_info",
      "checkout_single_page",
      "shipping_method",
      "checkout_payment",
    ];

    if (ineligibleTemplates.includes(ovData.template)) return false;
  }

  if (platform === 'bigcommerce') {
    if (ovData.page_type === "checkout") return false;
  }

  if (platform === 'shopline') {
    if (ovData.page_type === "checkout") return false;
  }

  if (platform === 'wix') {
    if (ovData.page_type === 'checkout') return false;
  }

  return true;
}
